class VideoBanner extends HTMLElement {
	constructor() {
		super();
		this.videoPreview = null;
		this.hasLoaded = false;
		this.videoUrl = this.getAttribute('data-video-src');
		this.videoAlt = this.getAttribute('data-video-alt') || 'Video';
	}

	connectedCallback() {
		this.videoPreview = this.querySelector('.video-banner__video-preview');
		window.addEventListener('scroll', () => this.checkPosition());
		requestAnimationFrame(() => this.checkPosition());
	}

	checkPosition() {
		const rect = this.getBoundingClientRect();
		const distanceFromViewportBottom = rect.top - window.innerHeight;

		if (!this.hasLoaded && distanceFromViewportBottom <= 800) {
			this.createVideo();
			this.hasLoaded = true;
		}
	}

	getVideoType(url) {
		if (url.includes('vimeo.com')) return 'vimeo';
		if (url.includes('youtube.com') || url.includes('youtu.be')) return 'youtube';
		return null;
	}

	getYoutubeId(url) {
		try {
			if (url.includes('youtu.be')) return url.split('/').pop();
			return new URL(url).searchParams.get('v');
		} catch (e) {
			return null;
		}
	}

	getVimeoId(url) {
		try {
			const parts = url.split('/');
			const rawId = parts.pop() || parts.pop();
			return rawId.split('?')[0].split('#')[0];
		} catch (e) {
			return null;
		}
	}

	createVideo() {
		const videoType = this.getVideoType(this.videoUrl);

		if (videoType === 'youtube') {
			const videoId = this.getYoutubeId(this.videoUrl);
			if (videoId) {
				const iframe = document.createElement('iframe');
				iframe.classList.add('video-banner__video');
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allow', 'autoplay; encrypted-media');
				iframe.setAttribute('allowfullscreen', '');
				iframe.setAttribute('title', this.videoAlt || 'YouTube video');
				iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&mute=1&showinfo=0&modestbranding=1&rel=0&enablejsapi=1`;
				this.appendChild(iframe);
			}
		}

		else if (videoType === 'vimeo') {
			const videoId = this.getVimeoId(this.videoUrl);
			if (videoId) {
				const iframe = document.createElement('iframe');
				iframe.classList.add('video-banner__video');
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allow', 'autoplay; encrypted-media');
				iframe.setAttribute('allowfullscreen', '');
				iframe.setAttribute('title', this.videoAlt || 'Vimeo video');
				iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&mute=1&background=1&title=0&byline=0&portrait=0`;
				this.appendChild(iframe);
			}
		}
	}
}

customElements.define('video-banner', VideoBanner);
